import React from 'react';
import ReactDOM from 'react-dom';
import _path from 'ramda/src/path';
import FeedContainer from '../Common/Feed/FeedContainer';
import FeedDataSource from '../Common/Feed/FeedDataSourceEnum';
import { MessageProvider } from '../Common/Message';



const hashtag = _path(['gHashTag'], window);
ReactDOM.render(
	<React.StrictMode>
		<MessageProvider>
			<FeedContainer hashtag={hashtag} datasrc={FeedDataSource.onPage} page='hashtag'/>
		</MessageProvider>
	</React.StrictMode>,
	document.querySelector('#HashtagPageComponent')
);
